<template>
  <div>
    <toolbar-view title="Шаблоны сообщений">
      <template v-slot:barActions>
        <v-btn icon @click="view = view===null ? 'search' : null;searchText=null"><v-icon>mdi-magnify</v-icon></v-btn>
        <v-btn icon @click="view = view===null ? 'create' : null"><v-icon>mdi-plus</v-icon></v-btn>
        <v-btn icon @click="refresh()"><v-icon>mdi-refresh</v-icon></v-btn>
      </template>
    </toolbar-view>
    <v-text-field v-show="view==='search'" v-model="searchText" class="mx-4 pt-2 mb-4" label="Введите текст для поиска..." clearable outlined dense hide-details/>
    <v-tabs v-if="(view===null || view==='search') && templates().length>0" v-model="tab" background-color="transparent" fixed-tabs>
      <v-tab>Все ({{templates().length}})</v-tab>
      <v-tab>Waba ({{templates('whatsappWaba').length}})</v-tab>
    </v-tabs>
    <v-sheet :max-height="height-48-48-(view==='search' ? 64 : 0)" class="overflow-y-auto">
      <progress-page v-if="state.loading && state.data.count===0"/>
      <div v-show="view==='create'" class="px-4 pt-2">
        <v-textarea v-model="createText" label="Текст" outlined dense auto-grow rows="1" hide-details class="mb-4"/>
        <chats-message-tags/>
        <v-row no-gutters>
          <v-col>
            <v-btn @click="view=null" depressed small class="mr-2">Отмена</v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn @click="create()" :loading="stateCreate.loadingUpdate" depressed small>Создать</v-btn>
          </v-col>
        </v-row>
      </div>
      <v-list v-show="view===null || view==='search'" dense class="pa-0">
        <div v-if="state.success && templates().length===0" class="text-center"><alert>Не найдено</alert></div>
        <v-list-item
            v-for="(item, i) in templates(tab===0 ? null : 'whatsappWaba')"
            :key="i"
            @click="selectTemplateSelect(item)" class="pa-0"
        >
          <v-row no-gutters>
            <v-col cols="auto" class="py-2 px-4 body-2" v-html="$tools.nl2br(item.text)"></v-col>
            <v-col v-if="item.buttons.length>0" cols="12" class="caption px-3 pb-3">
              Действия: {{item.buttons.join(', ')}}
            </v-col>
            <v-col cols="12" class="caption px-3 pb-3">
              <btn-small-accept btn-class="mr-2" @accept="remove(item.id)" name="Удалить"/>
              <v-btn @click="sort(item.id, true)" depressed small class="mr-2"><v-icon small color="grey">mdi-chevron-up-circle</v-icon></v-btn>
              <v-btn @click="sort(item.id, false)" depressed small><v-icon small color="grey">mdi-chevron-down-circle</v-icon></v-btn>
            </v-col>
            <v-col cols="12">
              <v-divider/>
            </v-col>
          </v-row>
        </v-list-item>
      </v-list>
      <dialog-view
          :open="selectTemplateOpen"
          title="Введите значение текстовых тегов"
          content-full-size
          width="900"
          :loading="selectTemplateState.loading"
          @cancel="selectTemplateOpen=false"
      >
        <template v-slot:content>
          <div v-if="selectTemplate!==null">
            <v-expansion-panels v-model="opens" accordion multiple>
              <v-expansion-panel>
                <v-expansion-panel-header class="font-weight-medium px-4">Пример</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div v-html="$tools.nl2br(selectTemplate.textExample)" class="mx-n2"></div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="font-weight-medium px-4">Результат</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div v-html="$tools.nl2br(selectTemplate.textResult)" class="mx-n2"></div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-divider/>
            <div class="ma-4">
              <div class="caption mb-2">Значения</div>
              <v-row class="rowSmall">
                <v-col
                    v-for="(v, k) in selectTemplate.textTags"
                    :key="k"
                    cols="4"
                >
                  <v-text-field
                      :label="v.alias"
                      :hint="$tools.isEmpty(v.example) ? null : 'Пример:'+v.example"
                      v-model="v.value"
                      @keyup="selectTemplateSelectUpdate()"
                      dense outlined hide-details="auto"
                  >
                    <template v-slot:append>
                      <tooltip-view v-if="v.auto">
                        <template v-slot:action>
                          <v-icon>mdi-refresh-auto</v-icon>
                        </template>
                        <template v-slot:content>
                          <div class="caption mb-2">
                            Для это текстового тега включена авто генерация значения.<br/>
                            Введите свое значение или оставьте поле пустым,<br/>
                            тогда позже данные могут быть сгенерированы автоматически
                          </div>
                        </template>
                      </tooltip-view>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </div>
          </div>
        </template>
        <template v-slot:actions>
          <v-row no-gutters>
            <v-col></v-col>
            <v-col cols="auto">
              <v-btn @click="selectTemplateAction()" text color="primary">
                Вставить
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </dialog-view>
    </v-sheet>
  </div>
</template>

<script>
import BtnSmallAccept from "../../../../componentsV2/base/BtnSmallAccept.vue";
import Stater from "@/plugins/stater";
import axios from "axios";
import Api from "@/Api";
import ToolbarView from "@/components/ToolbarView.vue";
import {Entity_MessageTemplate} from "../../../../../EntityStoreCacheService";
import ChatsMessageTags from "@/views/ContactCenter/Messenger/components/ChatsMessageTags.vue";
import DialogView from "@/components/DialogView.vue";
import Alert from "@/componentsV2/base/Alert.vue";
import ProgressPage from "@/components/ProgressPage.vue";
import TooltipView from "@/components/TooltipView.vue";

export default {
  components: {TooltipView, ProgressPage, Alert, DialogView,ChatsMessageTags, ToolbarView, BtnSmallAccept},
  props: ['items','comContact','chat','selectAllowed','height'],
  data: () => ({
    state: new Stater({items:[],count:0}),
    view:null,
    tab:0,
    searchText:null,
    stateCreate: new Stater(),
    createText:null,
    selectTemplate:null,
    selectTemplateOpen:false,
    selectTemplateState: new Stater(),
    opens:[1]
  }),
  mounted() {
    this.load();
  },
  watch:{
    chat: {
      deep: true,
      handler() {
        this.load();
      },
    }
  },
  methods:{
    load(){
      new Entity_MessageTemplate()
          .selects(Entity_MessageTemplate.id)
          .selects(Entity_MessageTemplate.sort)
          .selects(Entity_MessageTemplate.sid)
          .selects(Entity_MessageTemplate.text)
          .selects(Entity_MessageTemplate.messengerType)
          .selects(Entity_MessageTemplate.messengerType)
          .virtual(Entity_MessageTemplate.virtual_allowSend, this.chat?.id)
          .virtual(Entity_MessageTemplate.virtual_buttons)
          .virtual(Entity_MessageTemplate.virtual_textTags)
          .order(Entity_MessageTemplate.sort, true)
          .onPage(1000)
          .filterAnd([Entity_MessageTemplate.entity, Entity_MessageTemplate.status].join('.')+'=?', 'active')
          .addStateCallback((v) => this.state.setRequestBuilderState(v, false))
          .addStateCallback((v) => {
            if (v.success)
              this.$emit('update:items', v.items);
          })
          .request()
    },
    templates(messengerType=null){
      let arr = this.state.data.items;
      if(!this.$tools.isEmpty(this.searchText))
        arr = arr.filter(v=>v.text.toLowerCase().includes(this.searchText.toLowerCase()))
      if(messengerType!==null)
        arr = arr.filter(v=>v.messengerType===messengerType)
      if(this.$tools.isDefined(this.comContact?.messengerType))
        arr = arr.filter(v=>v.allowSend.includes(this.comContact?.messengerType))
      return arr;
    },
    create(){
      axios.post(Api.host+'/messenger/messageTemplate/',{
        text:this.createText
      }).then(()=>{
        this.view = null;
        this.createText = null;
        this.load();
      });
    },
    remove(id){
      axios.put(Api.host+'/messenger/messageTemplate/'+id+'/',{
        status:'deleted'
      }).then(()=>{
        this.load();
      });
    },
    sort(id, isUp){
      this.stateCreate.stateLoadingUpdate();
      axios.put(Api.host+'/messenger/messageTemplate/'+id+'/', {
        sortDirection:isUp ? 'up': 'down',
      }).then(()=>{
        this.stateCreate.stateSuccess();
        this.load();
      });
    },
    selectTemplateSelect(item){
      if(!this.selectAllowed)
        return;

      this.selectTemplateState.stateLoading()
      axios.post(Api.host+'/messenger/messageTemplate/'+item.id+'/preview/',{
        userId: this.chat?.info.userClient.userId,
        textTags:[]
      }).then(r=>{
        this.selectTemplate = r.data;
        if(this.selectTemplate.textTags.length===0){
          this.selectTemplateAction();
        } else {
          this.selectTemplateOpen = true;
        }
        this.selectTemplateState.stateSuccess()
      }).catch(()=>{
        this.selectTemplateState.stateError()
      });
    },
    selectTemplateSelectUpdate(){
      this.selectTemplateState.stateLoading()
      this.$tools.debounce(()=>{
        axios.post(Api.host+'/messenger/messageTemplate/'+this.selectTemplate.id+'/preview/',{
          userId: this.chat?.info.userClient.userId,
          textTags:this.selectTemplate.textTags
        }).then(r=>{
          this.selectTemplate = r.data;
          this.selectTemplateState.stateSuccess()
        }).catch(()=>{
          this.selectTemplateState.stateError()
        });
      },500, 'updateSelectTemplateAction');
    },
    selectTemplateAction(){
      this.selectTemplateOpen = false;
      this.$emit('select', this.selectTemplate)
    },
    refresh(){
      this.state = new Stater({items:[],count:0});
      this.state.stateLoading()
      axios.put(Api.host+'/messenger/messageTemplate/sync/').then(()=>{
        this.load();
      });
    }
  }
}
</script>